import React from 'react';
import { FilterLink, SelectLinks } from '../../../_lib/components/SelectLinks/SelectLinks';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type RolesFilter = {
  roles: FilterLink[];
};

export function RolesFilter({ roles }: RolesFilter) {
  const { t } = useSonTranslation('StructuralPageToPage');

  const mappedLinksWithTranslation = roles?.map(link => ({
    ...link,
    name: link.name === 'all' ? t('filter.all') : link.name,
  }));
  return (
    mappedLinksWithTranslation && (
      <div className="structural-page-to-page-tree__filters-box">
        <SelectLinks headline={t('filter.roles.headline')} links={mappedLinksWithTranslation} />
      </div>
    )
  );
}
